import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/medicare-irmaa-calculator',
  component: () => import('../../routes/MedicareIrmaaCalculator.svelte'),
  card: {
    id: 'medicare-irmaa-calculator',
    title: 'Medicare IRMAA Calculator',
    description: 'Calculate the Income-Related Monthly Adjustment Amount (IRMAA) for Medicare Part B and Part D premiums based on your MAGI and filing status.',
    icon: 'health_and_safety',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/medicare-irmaa-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Medicare IRMAA Calculator – Income-Related Premium Adjustment Calculator',
    description: 'Free Medicare IRMAA calculator to estimate your Income-Related Monthly Adjustment Amount. Calculate additional Part B and Part D premiums based on your MAGI and filing status for 2025.',
  },
};

export default meta;